import {Component, HostListener, OnDestroy, OnInit, ViewChild, inject, ChangeDetectionStrategy} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {LoginService} from '@services/login.service';
import {NotificacoesService} from '@services/notificacoes.service';
import {UsuarioPermissaoService} from '@services/usuario-permissao.service';
import {ToastrService} from 'ngx-toastr';
import {firstValueFrom, interval, of, Subscription} from 'rxjs';
import {catchError, exhaustMap, filter, take} from 'rxjs/operators';
import {AlertResumoImportacaoComponent} from 'src/app/components/alert-resumo-importacao/alert-resumo-importacao.component';
import {LocalStorageDecorator} from 'src/app/libs/local-storage-decorator';
import {HistoricoImportacoesService} from 'src/app/services/historico-importacoes.service';
import {UploadFileService} from 'src/app/services/upload-file.service';
import {HttpResponse } from '@angular/common/http';
import {FilenameParser} from '@utils/FilenameParser';
import {FileDownloadService} from '@services/file-download.service';
import { FileExtensionsService } from '@services/file-extensions.service';
import { FazerPedidoService } from '@services/fazer-pedido.service';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { GoogleTagManagerModel } from 'src/app/models/google-tag-manager.model';
import { TagManagerService } from '@services/tag-manager.service';
import { HeaderComponent } from '../../components/header/header.component';
import { AlertLoadingComponent } from '../../components/alert-loading/alert-loading.component';
import { AlertResumoImportacaoComponent as AlertResumoImportacaoComponent_1 } from '../../components/alert-resumo-importacao/alert-resumo-importacao.component';
import { AlertSucessoComponent } from '../../components/alert-sucesso/alert-sucesso.component';
import { AlertErroComponent } from '../../components/alert-erro/alert-erro.component';
import { AlertErroDadosComponent } from '../../components/alert-erro-dados/alert-erro-dados.component';
import { AlertInconsistenciasComponent } from '../../components/alert-inconsistencias/alert-inconsistencias.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertGenericoComponent } from '../../components/alert-generico/alert-generico.component';
import { AlertRecargaCertaComponent } from '../../components/alert-recarga-certa/alert-recarga-certa.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertErroCustomizadoComponent } from '../../components/alert-erro-customizado/alert-erro-customizado.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { SelectComponent } from '../../components/select/select.component';
import { FormsModule } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { NgClass, AsyncPipe } from '@angular/common';
import { LateralImportadorPedidosComponent } from '../../components/lateral-importador-pedidos/lateral-importador-pedidos.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-importador-dados',
    templateUrl: './importador-dados.component.html',
    styleUrls: ['./importador-dados.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, AlertLoadingComponent, AlertResumoImportacaoComponent_1, AlertSucessoComponent, AlertErroComponent, AlertErroDadosComponent, AlertInconsistenciasComponent, LoadingGenericoComponent, AlertGenericoComponent, AlertRecargaCertaComponent, BotaoChatComponent, AlertErroCustomizadoComponent, RouterLink, BreadcrumbComponent, TagManagerDirective, SelectComponent, FormsModule, PopoverDirective, NgClass, LateralImportadorPedidosComponent, FooterComponent, AsyncPipe, CamelCasePipe, UsuarioPermissaoPipe]
})
export class ImportadorDadosComponent implements OnInit, OnDestroy {
  private readonly tagManagerService = inject(TagManagerService);
  private readonly sectionApp = 'importacao-realizacao-pedidos';
  private readonly screenName = 'importacao-realizacao-pedidos:home';
  private readonly screenType = 'pagina';
  @ViewChild(AlertResumoImportacaoComponent)
  alertResumoImportacaoComponent: AlertResumoImportacaoComponent;

  // Variáveis dos ALERTS, para exibir os MODALS na tela
  public showModal:
    | 'AlertLoading'
    | 'AlertResumoImportacao'
    | 'AlertSucesso'
    | 'AlertErro'
    | 'AlertErroDados'
    | 'AlertInconsistencia'
    | 'LoadingGenerico'
    | 'UploadingFile'
    | '';

  @LocalStorageDecorator()
  public tituloAlertSucesso = '';
  @LocalStorageDecorator()
  public substituloAlertSucesso = '';

  @LocalStorageDecorator()
  public mensagemErroApi =
    'Erro referente ao layout do arquivo, por favor arrume o arquivo e importe-o de novo.';

  @LocalStorageDecorator()
  public mensagemInconsistenciaApi =
    'A importação do arquivo foi realizada porém com algumas inconsistências, clique em reparar ou voltar para cancelar o processo.';
  public avisoInconsistencia;

  // Campos que capturei no formulário da página
  public file = new FormData();
  public tipoCodigoBeneficio = 'F';
  public nomeArquivo = 'Selecionar arquivo';
  public pedidoRecargaCerta = false;
  public ajusteAutomatico: any;
  // Informações da empresa pra consultar API
  @LocalStorageDecorator('idEmpresaLogada', false)
  public idEmpresaLogada: any;
// Status do UPLOAD DE ARQUIVO
  @LocalStorageDecorator()
  public statusUploadApi: any = 0;
  @LocalStorageDecorator()
  public statusFaseApi: any = 0;
  // ID DA IMPORTAÇÃO PARA VERIFICAR SE HOUVE FALHAS
  @LocalStorageDecorator('idImportacao')
  public idImportacao: any;
  // DADOS DO RESUMO DE IMPORTAÇÃO
  @LocalStorageDecorator()
  public dadosResumoImportacao: any;

  public historicoImportacao: any = null;
  pedidoRecargaCertaVerifica: any;
  recargaCerta: any;

  subscriptions: Array<Subscription> = [];
  isUploadingFile = false;
  uploadingFileMessage =
    'Seu arquivo está sendo carregado, por favor, aguarde.';

  modalUploadingFile = {
    buttons: [
      {
        action: () => {
          this.checkImportacaoAndamento();
        },
        className: 'btn btn-outline-success mx-3',
        text: 'Ok',
      },
    ],
    description: this.uploadingFileMessage,
    message: 'Aguarde o carregamento',
    type: 'warning',
  };

  @LocalStorageDecorator() notificacaoId;
  public layout: any;
  public produtos: any;
  public enderecos: any;
  public flagRC: boolean;
  public showAlertErro: boolean;
  public tituloErroApi: string;
  public fileSelected: any = null;
  public fileName: any;
  public fileExtension: string;
  public config:any;

  public mensagemRecargaCerta: string;
  public alertRecargaCerta: boolean;

  private readonly featureName = 'importador-dados';
  public allowedExtensions: string[] = [];

  constructor(
    private readonly service: UploadFileService,
    private readonly serviceHistoricoImportacoes: HistoricoImportacoesService,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly router: Router,
    private readonly notificacoesService: NotificacoesService,
    private readonly Toastr: ToastrService,
    private readonly fileExtensionService: FileExtensionsService,
    private readonly fazerPedidoService: FazerPedidoService,
    private readonly uploadFileService: UploadFileService,
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem(`${this.idEmpresaLogada}.sawImportationError`)) {
      this.router.navigate(['/visualizar-erros-importacao']);
    }

    this.getRecargaCerta();
    this.checkImportacaoAndamento();
    this.consultaHistoricoImportacoes();
    this.getAllowedExtensions();
    this.addTagManagerScreenView();
  }

  getAllowedExtensions() {
    this.fileExtensionService.getFeatureAllowedExtensions(this.featureName)
    .subscribe(fileExtension => {
      this.allowedExtensions = fileExtension.extensions.map((ext: any) => ext as string);    });
  }

  ngOnDestroy() {
    this.beforeunload();
    if (!this.isUploadingFile) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunload(event?: BeforeUnloadEvent) {
    if (
      this.showModal === 'AlertSucesso' ||
      this.showModal === 'LoadingGenerico'
    ) {
      this.showModal = '';
    }

    this.statusUploadApi = undefined;
    this.statusFaseApi = undefined;

    if (event && this.isUploadingFile) {
      event.preventDefault();
    }
  }

  capturarArquivoAws(event: any) {
    if(this.allowedExtensions.length == 0) {
      this.Toastr.error('Nenhuma extensão de arquivo é permitida.');
      return;
    }

    this.file = new FormData();
    this.fileSelected = event.target.files[0];
    this.nomeArquivo = 'Selecionar arquivo';
    const data = new Date();
    const dia = data.getDate();
    const mes = data.getMonth() + 1;
    const ano = data.getFullYear();
    const hora = data.getHours();
    const min = data.getMinutes();
    const segundo = data.getSeconds();
    this.fileExtension = '.' + [event.target.files[0].name.split('.').pop()];

    if(!this.allowedExtensions.includes(this.fileExtension.toLowerCase())) {
      this.Toastr.error(`Extensão ${this.fileExtension} não é permitida.`);
      return;
    }

    this.fileSelected = new File([event.target.files[0]],
    this.fileSelected.name.substr(0, this.fileSelected.name.lastIndexOf('.') ?? this.fileSelected.name)
      + '_' + dia + mes + ano + hora + min + segundo + this.fileExtension, {type: this.fileSelected.type});
    this.fileName = this.fileSelected.name;
    if (this.fileSelected) {
      this.nomeArquivo = this.fileSelected.name;
      this.file.append('file', this.fileSelected);
    } else {
      this.Toastr.error('Por favor, selecione um arquivo.');
    }
  }

  async enviarArquivoAws() {
    try {
      const preSignedUrl: string = await firstValueFrom(this.service.getS3PreSignedUploadUrl(this.fileSelected.name));
      const urlWithoutDomain: string = preSignedUrl.split('/').slice(3).join('/');

      await firstValueFrom(this.service.uploadFileToS3(urlWithoutDomain, this.fileSelected));

      this.novoArquivo();
    } catch (error) {
      console.error(error);
      this.showModal = 'AlertErro';
    }
  }

  novoArquivo(){
    this.service.novoArquivo(this.nomeArquivo, this.idEmpresaLogada, this.tipoCodigoBeneficio, this.ajusteAutomatico,
      this.pedidoRecargaCerta, this.fileSelected).pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.isUploadingFile = false;
          if (response.status === 'OK' || response.mensagem === 'Existe uma importação em andamento.') {
            this.idImportacao = response.response.importId;
            this.limparArquivo();
            this.statusImportacao();
          } else {
            this.showAlertErro = true;
            this.tituloErroApi = 'Ocorreu um erro!';
            this.mensagemErroApi = response.mensagem;
            this.showModal = '';
            this.limparArquivo();
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.showModal = 'AlertErro';
        }
      });
  }

  limparArquivo(){
    this.nomeArquivo = 'Selecionar arquivo';
    const inputFile = document.querySelector<HTMLInputElement>(
      '#inputFile'
    );
    if (inputFile) {
      inputFile.value = '';
    }
  }

  // API é chamada para checar o status da importação.
  statusImportacao() {
    this.showModal = 'AlertLoading';
    const subscription = interval(3000)
      .pipe(
        exhaustMap(() =>
          this.service
            .recuperarStatusImportacao(this.idImportacao)
            .pipe(
              catchError((error) => {
                console.error(error);
                return of();
              })
            )
        )
      )
      .subscribe({
        next: (response: any) => {
          localStorage.setItem('idImportacao', response.idImportacao);
          this.statusUploadApi = response.quantidadePorcentagemFase;
          this.statusFaseApi = response.codigoFase;
          if (response.descricaoStatus === 'PROCESSAMENTO COM ERRO') {
            localStorage.idImportacao = this.idImportacao;
            this.showModal = 'AlertErro';
            this.mensagemErroApi = response.erro
              ?? 'Ocorreu um erro durante a importação, por favor verifique os erros e suba o arquivo novamente.';
            subscription.unsubscribe();
            logoutSubscription.unsubscribe();
            this.notificacaoId = undefined;
            this.notificacoesService.remover(this.notificacaoId);
          } else if (response.descricaoStatus === 'AGUARDANDO DEFINIÇÃO' && response.descricaoFase === 'IMPORTAÇÃO DOS DADOS') {
            subscription.unsubscribe();
            logoutSubscription.unsubscribe();
            this.notificacaoId = undefined;
            this.showModal = '';
            this.preConclusaoImportacao();
          } else if (response.descricaoStatus === 'AGUARDANDO DEFINIÇÃO' && response.descricaoFase === 'RESUMO DE PROBLEMAS') {
            if (localStorage.getItem('tratativas')) {
              this.router.navigate(['/tratativas'], {
                queryParams: {
                  recargaCerta: this.pedidoRecargaCerta
                }
              });
            } else {
              subscription.unsubscribe();
              logoutSubscription.unsubscribe();
              this.notificacaoId = undefined;
              this.showModal = 'AlertInconsistencia';
              this.avisoInconsistencia = true;
              this.mensagemInconsistenciaApi =
                'A importação do arquivo foi realizada porém com algumas inconsistências, clique em reparar ou voltar para cancelar o processo.';
              this.statusUploadApi = 0;
              this.statusFaseApi = 0;
              this.file = new FormData();
              this.limparArquivo();
            }
          }
        },
        error: (erro: any) => {
          console.error('Erro ao consultar o status', erro);
          subscription.unsubscribe();
          logoutSubscription.unsubscribe();
          this.notificacaoId = undefined;
        }
      });
    this.subscriptions.push(subscription);
    const logoutSubscription = LoginService.events$
      .pipe(filter((event) => event.type === 'logout'))
      .subscribe(() => {
        subscription.unsubscribe();
        logoutSubscription.unsubscribe();
        this.notificacaoId = undefined;
      });
    this.subscriptions.push(logoutSubscription);
  }

  // chamada para ver se há alguma importação em andamento.
  checkImportacaoAndamento(){
    this.service.checkImportacao(this.idEmpresaLogada).pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.descricaoFase !== 'IMPORTAÇÃO ENCERRADA'){
            this.idImportacao = response.idImportacao
            this.statusImportacao();
          }
        }, error: (error: any) => {
          console.error(error)
        }
      });
  }

  getRecargaCerta(){
    this.service.consultaRecargaCerta(localStorage.cnpj)
    .subscribe({
      next: (response: any) => {
      if (response.status === 'OK'){
        this.pedidoRecargaCerta = true;
      }
      }, error: (error: any) => {
        console.error(error)
      }
    });
  }

  async alertSucessoAvancou() {
    this.showModal = 'LoadingGenerico';
    this.showModal = '';
    this.fazerPedidoService.getInicioCalculoValores(this.idEmpresaLogada, '', this.idImportacao, this.pedidoRecargaCerta)
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.router.navigate(['/fazer-pedido-integral'], {
            queryParams: {
              recargaCerta: this.pedidoRecargaCerta,
            },
          });
        }
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

  eventoAlertSucesso(evento: any) {
    this.showModal = '';
  }

  eventoAlertErro(evento: any) {
    this.showModal = '';
    this.cancelarCapturaArquivo();
  }

  eventoAlertErroImportacao(){
    this.showAlertErro = false;
  }

  eventoAlertInconsistencia(evento: any) {
    this.showModal = '';
  }

  async eventoAlertResumoImportacao(event: any) {
    if (event === 'cancelar') {
      this.avisoInconsistencia = false;
      this.service
        .finalizaImportacao(this.idImportacao, 'cancelar')
        .pipe(take(1))
        .subscribe();
      this.showModal = '';
    }
    // CONCLUIR
    else if (event === 'concluir') {
      this.showModal = 'LoadingGenerico';
      this.service
        .concluirImportacao(this.idImportacao)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            this.checkStatusConclusao();
          },
          error: (erro: any) => {
            this.statusFaseApi = 0;
            this.statusUploadApi = 0;
            this.showModal = 'AlertErro';
            this.mensagemErroApi = 'Erro ao salvar os dados da importação.';
            this.service
              .finalizaImportacao(this.idImportacao, 'cancelar')
              .pipe(take(1))
              .subscribe();
          }
        });
    }
  }

  eventoAlertIgnorarDados(event: any) {
    this.showModal = 'AlertResumoImportacao';
    this.service
      .consultaResumoImportacao(this.idImportacao)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            this.dadosResumoImportacao = response.response;
            localStorage.idEmpresaPai = this.dadosResumoImportacao[0].idEmpresaPai;
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.dadosResumoImportacao = false;
        }
      });
  }

  public getDados() {
    this.serviceHistoricoImportacoes
      .getDadosEmpresa(this.idEmpresaLogada)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.pedidoRecargaCertaVerifica = success.response.pedidoRecargaCerta;
          this.recargaCerta = success.response.recargaCerta;

          if (this.pedidoRecargaCertaVerifica === 'Enviado') {
            this.showModal = 'AlertErro';
            this.pedidoRecargaCerta = false;
            this.mensagemErroApi =
              'Não é possível realizar neste momento o pedido com Recarga Certa, pois ainda estamos realizando o estudo de sua base de dados.';
          }

          if (this.recargaCerta === false) {
            this.showModal = 'AlertErro';
            this.pedidoRecargaCerta = false;
            this.mensagemErroApi =
              'Não há contrato de Recarga Certa para sua empresa. Você pode contratar este serviço através do menu: Exclusividades - Contratação Recarga Certa.';
          }
        },
        error: (erro: any) => {}
      });
    if (this.pedidoRecargaCerta === false){
      this.alertRecargaCerta = true;
    }
  }

  enviarImportacaoAws() {
    this.statusUploadApi = 0;
    this.statusFaseApi = 0;
    this.showModal = 'AlertLoading';
    this.isUploadingFile = true;

    if (this.pedidoRecargaCerta) {
      this.pedidoRecargaCerta = true;
    } else {
      this.pedidoRecargaCerta = false;
    }

    if (this.ajusteAutomatico) {
      this.ajusteAutomatico = true;
    } else {
      this.ajusteAutomatico = false;
    }

    this.enviarArquivoAws();

  }
  // EXIBIR ALERT DE RESUMO DE IMPORTAÇÃO PASSANDO IDIMPORTAÇÃO
  exibirResumoImportacao() {
    this.showModal = 'AlertResumoImportacao';
    localStorage.idImportacao = this.idImportacao;

    this.service
      .resumoImportacao(this.idImportacao)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.showModal = 'AlertResumoImportacao';
          this.dadosResumoImportacao = response;
          localStorage.idImportacao = this.idImportacao;
          localStorage.idEmpresaPai = this.dadosResumoImportacao.summaryCompanys[0].companyId;
        },
        error: (erro: any) => {
          console.error(erro);
          this.dadosResumoImportacao = false;
        }
      });
  }

  preConclusaoImportacao() {
    this.service.preConclusaoImportacao(this.idImportacao, false).subscribe({
      next: (response: any) => {
        this.showModal = 'LoadingGenerico';
        setTimeout(() => {
          this.exibirResumoImportacao();
        }, 1000);
      },
      error: (erro: any) => {
        console.error(erro);
        this.showModal = 'AlertErro';
      }
    });
  }

  // CONSULTA HISTÓRICO DE IMPORTAÇÕES (TABELA NO FINAL DA TELA)
  consultaHistoricoImportacoes() {
    if (this.idEmpresaLogada) {
      this.serviceHistoricoImportacoes
        .getImportacoes(this.idEmpresaLogada, 0, 5, null, null)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            this.historicoImportacao = response.response.content;
          },
          error: (erro: any) => {
            if (erro.error.mensagem === 'Sem historico de importacao') {
              this.historicoImportacao = undefined;
            } else {
              this.historicoImportacao = false;
            }
          }
        });
    } else {
      this.historicoImportacao = false;
    }
  }

  // Apenas para excluir o arquivo selecionado, clicando no botao CANCELAR apenas para não subir
  cancelarCapturaArquivo() {
    this.nomeArquivo = 'Selecionar arquivo';
    this.file = new FormData();
    const inputFile = document.querySelector<HTMLInputElement>(
      '#inputFile'
    );
    inputFile.value = '';
  }

  cancelarImportacao() {
    this.showModal = 'LoadingGenerico';
    this.service
      .finalizaImportacao(this.idImportacao, 'cancelar')
      .pipe(take(1))
      .subscribe((response: any) => {
        this.showModal = '';
        this.avisoInconsistencia = false;
        this.checkImportacaoAndamento();
      });
  }

  navigateToFazerPedidoIntegral() {
    this.router.navigate(['/fazer-pedido-integral'], {
      queryParams: {
        recargaCerta: this.pedidoRecargaCerta,
      },
    });
  }

  downloadImportacao(importacao){
    this.serviceHistoricoImportacoes.downloadImportacao(this.idEmpresaLogada, importacao.idImportacao)
    .pipe(take(1))
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'));
        FileDownloadService.download([body], filename);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  eventoAlertRecargaCerta(evento: any){
    this.pedidoRecargaCerta = evento;
    this.alertRecargaCerta = false;
  }

  downloadErrosImportacao(idImportacao: any) {
    this.uploadFileService.getDownloadInconsistencias(idImportacao)
      .pipe(take(1))
      .subscribe({
        next: ({body, headers}: HttpResponse<any>) => {
          const filename = FilenameParser.fromContentDispositionHeader(
            headers.get('content-disposition'),
            'Arquivo.csv',
          );
          FileDownloadService.download([body], filename);
        },
        error: (error) => {
          this.Toastr.error(error.error.mensagem, '', {
            timeOut: 2000,
          });
        }
      });
  }

  addTagManagerInteraction(elementType: string, elementContent: string): GoogleTagManagerModel {
    return this.buildTagModel(GoogleTagManagerEventEnum.interaction, elementType, elementContent);
  }

  private addTagManagerScreenView(): void {
    this.tagManagerService.pushTag(this.buildTagModel(GoogleTagManagerEventEnum.screenView, null, null));
  }

  private buildTagModel(event: GoogleTagManagerEventEnum, elementType: string, elementContent: string): GoogleTagManagerModel {
    const model = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = this.sectionApp;
    model.screen_name = this.screenName;
    model.screen_type = this.screenType;
    return model;
  }

  private checkStatusConclusao() {
    const subscription = interval(3000)
      .pipe(
        exhaustMap(() =>
          this.uploadFileService
            .getStatusConclusaoImportacao(this.idImportacao)
            .pipe(
              catchError((error) => {
                console.error(error);
                return of();
              })
            )
        )
      )
      .subscribe({
        next: (response: any) => {
          if (response.response.status === 'FINALIZADA') {
            subscription.unsubscribe();
            localStorage.removeItem('tratativas');
            this.tituloAlertSucesso = 'Importação realizada com sucesso!';
            this.substituloAlertSucesso =
              'Clique em avançar se deseja fazer um pedido com importação de dados ou sair.';
            this.showModal = 'AlertSucesso';
          } else if (response.response.status === 'ERRO') {
            subscription.unsubscribe();
            localStorage.removeItem('tratativas');
            this.showAlertErro = true;
            this.mensagemErroApi = 'Erro ao salvar os dados da importação.';
            this.service.finalizaImportacao(this.idImportacao, 'cancelar').subscribe();
          }
        },
        error: (erro: any) => {
          subscription.unsubscribe();
          localStorage.removeItem('tratativas');
          this.showModal = '';
          this.showAlertErro = true;
          this.mensagemErroApi = 'Erro ao salvar os dados da importação.';
          this.service.finalizaImportacao(this.idImportacao, 'cancelar').subscribe();
        }
      });
    this.subscriptions.push(subscription);
  }
}
